import Joi from "joi";

export interface EditCheckListModelTaskDTO {
  id: number;
  title?: string;
  description?: string;
  order?: number;
  active?: boolean;
  checkListModelId: number;
}

export const EditCheckListModelTaskDTOSchema = Joi.object({
  id: Joi.number().required().messages({
    "any.required": "O id é obrigatório",
    "number.base": "O id deve ser um número",
  }),
  title: Joi.string()
    .trim()
    .required()
    .messages({
      "string.base": "O título deve ser um texto",
      "string.empty": "O título não pode ser vazio",
      "any.required": "O título é obrigatório",
    }),
  description: Joi.string().optional().allow(null, "").max(250).messages({
    "string.base": "A descrição deve ser um texto",
    "string.max": "A descrição não pode ter mais de 250 caracteres",
  }),
  order: Joi.number().optional().greater(0).messages({
    "number.base": "A ordem deve ser um número",
    "number.greater": "A ordem deve ser maior que 0",
  }),
  active: Joi.boolean().optional().messages({
    "boolean.base": "O campo ativo deve ser verdadeiro ou falso",
  }),
  checkListModelId: Joi.number()
    .required()
    .messages({
      "number.base": "O ID do modelo de checklist deve ser um número",
      "any.required": "O ID do modelo de checklist é obrigatório",
    }),
});
